import React from "react";
import DynamicTable from "../../../../../library/custom/dynamicTable/dynamicTable";
import {
  getValueByKey,
  groundStabilizationColumns,
  lotDisturbanceColumns,
  observationColumns,
  RevisedMeasuresColumns,
} from "../../../../../utils/swInspectionHelper";
import { Grid } from "@mui/material";

const ViewNorthCarolina = (props) => {
  return (
    <>
      <Grid container mt={3}>
        {props?.swInspectionConfQuestionAns?.slice(0, 2)?.map((item) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              className="confQuestionAns"
              mb={2}
              key={item?.confQuesId}
            >
              <strong>{item?.confQues}:</strong>
              {getValueByKey(item?.confAns)}
            </Grid>
          );
        })}
      </Grid>

      <DynamicTable
        title="Ground Stabilization: Must be recorded after each phase of grading"
        columns={groundStabilizationColumns}
        data={props?.swInspectionGroundStabilization}
      />

      <DynamicTable
        title="Stormwater Discharge Outfalls"
        columns={observationColumns}
        data={props?.swInspectionObservation}
      />

      <DynamicTable
        title="New or Revised Measures"
        columns={RevisedMeasuresColumns}
        data={props?.swInspectionNewOrRevisedMeasure}
      />

      <DynamicTable
        title="Individual Lot Disturbance"
        columns={lotDisturbanceColumns}
        data={props?.swInspectionLotDisturbance}
      />
    </>
  );
};

export default ViewNorthCarolina;
